import React from "react";
import { array, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import PhotoStoryCard from "../../molecules/PhotoStoryCard";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug } from "../../utils/utils";

import "./photoStoryWithSlider.m.css";

const PhotoStoryWithSlider = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const stories = get(collection, ["items"], [])
    .filter(item => item.type === "story")
    .slice(0, 4);
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  if (!stories.length) {
    return null;
  }

  const photoStoryStack = stories.map((story, index) => {
    const imageType = index => (index === 1 ? "image2x1" : "image1x1");
    const aspectRatio = index => (index === 1 ? [2, 1] : [1, 1]);
    const widths = index === 0 ? [1000] : [650];
    const storyHeadlineStyle =
      index === 0
        ? `${publisherAttributes.lang}-story-headline-first`
        : `${publisherAttributes.lang}-story-headline-rest`;
    const getHeaderType = index => {
      switch (index) {
        case 0:
          return 31;
        case 1:
          return 3;
        default:
          return 20;
      }
    };

    return (
      <PhotoStoryCard
        key={index}
        story={story.story}
        headerLevel={2}
        headlineType={getHeaderType(index)}
        imageType={imageType(index)}
        cardImageWidths={widths}
        aspectRatio={aspectRatio(index)}
        headlineStyle={storyHeadlineStyle}
      />
    );
  });

  return (
    <div styleName="base" className="photo-story-slider" data-testid="slider-photo">
      <div styleName="wrapper">
        {showCollectionName && (
          <CollectionTitleWithArrow
            collectionName={collection.name}
            collectionSlug={collectionSlug}
            headlineClassName="collection-name-arrow"
            updatedFont={true}
          />
        )}
        <div styleName="photo-story-wrapper">{photoStoryStack}</div>
      </div>
    </div>
  );
};

PhotoStoryWithSlider.propTypes = {
  stories: array,
  collection: object,
  collectionName: string,
  sections: array,
  publisherAttributes: object,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps, null)(PhotoStoryWithSlider);
